// DataTable.tsx (컬럼/타입만 교체)

import * as React from 'react';
import {
    ColumnDef,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
} from '@tanstack/react-table';
import styles from './DataTable.module.scss';

type DataTableProps<T extends object> = {
    data: T[];
    columns: ColumnDef<T, any>[];
};

function DataTable<T extends object>({ data, columns }: DataTableProps<T>) {
    const [sorting, setSorting] = React.useState<SortingState>([]);

    const table = useReactTable({
        data,
        columns,
        state: { sorting },
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    return (
        <div className={styles['data-table__container']}>
            <table className={styles['table__wrapper']}>
                <thead>
                    {table.getHeaderGroups().map(hg => (
                        <tr key={hg.id}>
                            {hg.headers.map(h => (
                                <th
                                    key={h.id}
                                    onClick={h.column.getToggleSortingHandler()}
                                    style={{
                                        textAlign: 'left',
                                        padding: '10px 12px',
                                        fontWeight: 600,
                                        cursor: h.column.getCanSort() ? 'pointer' : 'default',
                                    }}
                                >
                                    {flexRender(h.column.columnDef.header, h.getContext())}
                                    {{
                                        asc: ' ▲',
                                        desc: ' ▼',
                                    }[h.column.getIsSorted() as string] ?? null}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id} style={{ padding: '10px 12px' }}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                    {table.getRowModel().rows.length === 0 && (
                        <tr>
                            <td colSpan={columns.length} style={{ padding: 20, textAlign: 'center', color: '#94a3b8' }}>
                                No data
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default DataTable;
